import api from '../../Services/api';
import * as types from '../actionTypes';
import * as config from '../../Config/api.js';
import jwtDecode from 'jwt-decode';
import { isAbortError } from '../../Services/abortError';
import logger from '../../Services/logger';
import authStorage from '../../Services/authStorage';
import { refreshAccessToken } from '../../Services/authRefresh';
	
export const setInnerLoading  = (loadingStatus) => { 
	return { 
		type: types.INNER_LOADING,
		payload: loadingStatus 
	}
};

export const setDialog  = (target,status) => { 
	return { 
		type: types.SET_DIALOG,
		payload: {target:target,status:status} 
	}
};

export const setLoginStatus  = (status) => { 
	return { 
		type: types.SET_LOGINSTATUS,
		payload: status
	}
};

export const setActivationStatus  = (status) => { 
	return { 
		type: types.SET_ACTIVATIONSTATUS,
		payload: status
	}
};

export const setCurrentCompanyStatus  = (status) => { 
	return { 
		type: types.SET_CURRENTCOMPANYSTATUS,
		payload: status
	}
};

export const setMasterUser  = (status) => { 
	return { 
		type: types.SET_MASTERUSER,
		payload: status
	}
};

export const setUserRights  = (value) => { 
	return { 
		type: types.SET_USERRIGHTS,
		payload: value
	}
};

export const setAgencyName  = (value) => { 
	return { 
		type: types.SET_AGENCYNAME,
		payload: value
	}
};


export const setAgencyUser  = (value) => { 
	return { 
		type: types.SET_AGENCYUSER,
		payload: value
	}
};

// convert input to desired output JSON	
function converterChaves(jsonEntrada) {
  const jsonSaida = jsonEntrada.map(obj => {
    return {
      code: obj.id,
      name: obj.nome
    };
  });

  return jsonSaida;
}

export const setRoutePanel  = (status) => { 

	return { 
		type: types.SET_ROUTEPANEL,
		payload: status
	}
};


export const setCurrentAgency  = (status) => { 

	return { 
		type: types.SET_CURRENTAGENCY,
		payload: status
	}
};

export const retrieveAppCities  = (id,props) => { 
		
		return dispatch => {
					
					var value = id;
	
					// Connect to retrieve content endpoint
					api({
						   url    : 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/'+value+'/municipios',
						   method : 'GET',
						   headers: {
							Accept: 'application/json'
						}
					})				
					
					.then((response) => {

						//logger.debug("[response]--->"+JSON.stringify(response,null,2));

						// Harded CODE for TERMS...
						props.setDropdownCityItems(converterChaves(response.data));
						props.setCityResult(true);
						props.setCityLoading(false);						
						return;
						
					})
					.catch(error=> {
						logger.debug("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
						return;
					});
					
	} // end dispatch

};

// ----------------------------------------------------------------------------
// NOTA: 5 thunks foram removidos daqui em 2026-06-05 — todos apontavam para
// /order/transfer/* (removido do backend) ou para api-testing.mozio.com.
// Nenhum era importado em qualquer componente. Eram resíduos de um módulo
// de transfer/transporte que nunca foi ativado no Dream4 — provável herança
// do mesmo fork que deixou as chaves @motuum/ purgadas no TD-021.
// Thunks removidos: retrieveAppAddressGooglePlaces,
// retrieveAppAddressesGoogleMatrixDistance, retrieveAppFlightsInfo,
// retrieveAppFlightAirportInfo, tryRetrieveAppFlightAirportInfo.
// ----------------------------------------------------------------------------

export const retrieveAndSetUserInfo  = (data,props) => {

	return dispatch => {

		// ===== Auth Fase 2 (B.2 — per-tab) =====
		// Sem sessão NESTA aba (sem access próprio e sem refresh), não roda validação
		// nem desloga — só garante login limpo. Evita o falso "chave de acesso
		// alterada" ao abrir uma nova aba sem "manter conectado" (o @dream4/userData
		// compartilhado no localStorage NÃO conta como sessão desta aba).
		if (!authStorage.hasTabSession()) {
			if (props.setGlobalLoading) props.setGlobalLoading(false);
			if (props.setLoginStatus) props.setLoginStatus(false);
			return;
		}

		// A identidade vem do ACCESS token (decodificado). NÃO usa mais a validação
		// token×hash do /user/retrieveData — ela é incompatível com o access curto/
		// rotativo (retornava invalidToken "chave de acesso alterada" no reload).
		if (authStorage.hasRefreshToken()) {
			const applyIdentity = () => {
				const info = authStorage.getDecodedAccessToken();
				if (!info || !info.CompanyPersonUserId) { props.logOut(); return; }
				const parts = String(info.AgencyLegalName || "").split(" ").filter(Boolean);
				const shortName = parts.slice(0, 2).join(" ") || info.AgencyLegalName || "";
				props.setMasterUser(info.Master === 0 ? false : true);
				props.setAgencyName(shortName);
				props.setAgencyUser(info.PersonCompleteName);
				props.setUserRights(info.Rights ? info.Rights : []);
				const cs = authStorage.getDecodedCompanyStatus();
				if (cs && cs.currentStatus != null) props.setCurrentCompanyStatus(cs.currentStatus);
				const as = authStorage.getDecodedActivationStatus();
				if (as && as.currentStatus != null) props.setActivationStatus(as.currentStatus);
				props.setGlobalLoading(false);
			};
			const expMs = authStorage.getAccessExpiryMs();
			if (!authStorage.getAccessToken() || (expMs && expMs <= Date.now())) {
				// Reload com access ausente/expirado -> silent-refresh e então aplica.
				refreshAccessToken().then(applyIdentity).catch(() => { props.logOut(); });
			} else {
				applyIdentity();
			}
			return;
		}

		// ===== Legado (pré-virada): validação token×hash via /user/retrieveData =====
		// Retrieve userData and userToken
		var result = JSON.stringify(authStorage.getUserData() || {});
		var userData = JSON.parse(result); 
		var userDataInfo = jwtDecode(userData.userToken); 
		var resultCompanyStatus = localStorage.getItem("@dream4/companyStatus");
		var resultActivationStatus = localStorage.getItem("@dream4/activationStatus");	

		// Set Company Short Name
		let tempCompanyName = userDataInfo.AgencyLegalName.split(" ");
		userDataInfo.AgencyShortLegalName = tempCompanyName[0]+" "+tempCompanyName[1];

		// Prepare POST data
		var preparedData = {
			statusToken:resultCompanyStatus,
			activationToken:resultActivationStatus
		}

		// Connect to retrieve content endpoint
		api({
			   url    : config.API_URL+'/api/v1/user/retrieveData',
			   method : 'POST',				   
			   data   : preparedData,
			   headers: {
				"x-access-token": userData.userToken,
				Accept: 'application/json',
			}
		})	
		.then((response) => {
		
			// Set Global loading off after 2 seconds
			setTimeout(() => {
				props.setGlobalLoading(false);
			}, 2000); 

			// If an error occured. Check retry flag 
			if (response.data.error) {					

				props.setAlertTitle("Ops! Não encontramos o seu usuário com a chave utilizada!");
				props.setAlertBody("Não foi possível encontrar o seu usuário e atualizar os dados de seu perfil de acesso. Faça o login novamente para corrigir.");				
				props.setAlert(true);

				props.logOut(); 				
				
				// Set logoff flag
				// localStorage.setItem("retryUserData",1);
				// localStorage.setItem("retryUserDataReason","Token error");
				// localStorage.setItem("retryUserDataLastUpdate",moment().format("YYYY-MM-DD HH:mm"));
				
				return;						
			} // end if	*/
								
			// Suceed.
			if (response.data.success) {
				
				// If user was not found, delete local info and go to login
				if (response.data.invalidToken ) {

					props.setAlertTitle("Ops! Parece que sua chave de acesso foi alterada!");
					props.setAlertBody("A chave de seu usuário está diferente da plataforma. A os dados do seu usuário ou agência podem ter sido atualizados enquanto estava ausente. Faça o login novamente para atualizar a chave de acesso. [1] ");				
					props.setAlert(true);

					props.logOut(); 					

					return;
				} // end if	
				
				// If token is expired, force login [MIGHT INVOKE THIS ACTION BY WEBSOCKET]
				if (response.data.expiredToken ) {

					props.setAlertTitle("Ops! Parece que há um sua chave de acesso expirou!");
					props.setAlertBody("A chave de acesso do seu usuário está expirada. Faça o login novamente para corrigir. [1] ");				
					props.setAlert(true);

					props.logOut(); 
									
					return;
				} // end if	
				
				// If no changes on sent token and received token 
				if (response.data.noChanges) {
	
					props.setMasterUser(userDataInfo.Master === 0 ? false : true);
					props.setAgencyName(userDataInfo.AgencyShortLegalName);
					props.setAgencyUser(userDataInfo.PersonCompleteName); 	
					props.setUserRights(userDataInfo.Rights ? userDataInfo.Rights : []);

					// Set CurrentCompanyStatus
					try {
						var companyStatusObjDecoded = jwtDecode(resultCompanyStatus); 
						var currentCompanyStatus = companyStatusObjDecoded.currentStatus;
						if (currentCompanyStatus == null) {
							props.setAlertTitle("Ops! Parece que há um erro nos dados armazenados!");
							props.setAlertBody("Desconectamos o seu usuário da plataforma pois ocorreu uma inconsistência nos dados armazenados no seu dispositivo. Faça o login novamente para corrigir. [1] ");				
							props.setAlert(true);
							props.logOut(); 
							return; 
						}
						props.setCurrentCompanyStatus(currentCompanyStatus);
					} catch(e) {
						logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (4) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
						props.logOut();
						return;
					} // end catch
	
					// Set ActivationStatus
					try {
						var activationStatusObjDecoded = jwtDecode(resultActivationStatus);
						var activationStatus = activationStatusObjDecoded.currentStatus;
						if (activationStatus == null) {
							props.setAlertTitle("Ops! Parece que há um erro nos dados armazenados!");
							props.setAlertBody("Desconectamos o seu usuário da plataforma pois ocorreu uma inconsistência nos dados armazenados no seu dispositivo. Faça o login novamente para corrigir. [2] ");				
							props.setAlert(true);
							props.logOut(); 
							return; 
						}
						props.setActivationStatus(activationStatus);
					} catch(e) {
						logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (5) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
						props.logOut();
						return;
					} // end catch						
					
									
					return;
				} // end if					
				
				props.setMasterUser(userDataInfo.Master === 0 ? false : true);
				props.setAgencyName(userDataInfo.AgencyShortLegalName);
				props.setAgencyUser(userDataInfo.PersonCompleteName); 	
				props.setUserRights(userDataInfo.Rights ? userDataInfo.Rights : []);

				// Check if status token has updateAt date before received token. 
				if (response.data.changedStatusToken) {
				
					try {
						var companyStatusObjDecoded = jwtDecode(response.data.companyStatusToken); 
						var currentCompanyStatus = companyStatusObjDecoded.currentStatus;
						if (currentCompanyStatus == null) {
							props.setAlertTitle("Ops! Parece que há um erro nos dados armazenados!");
							props.setAlertBody("Desconectamos o seu usuário da plataforma pois ocorreu uma inconsistência nos dados armazenados no seu dispositivo. Faça o login novamente para corrigir. [1] ");				
							props.setAlert(true);
	
							props.logOut(); 
							return; 
						}
						localStorage.setItem("@dream4/companyStatus",response.data.companyStatusToken)
						props.setCurrentCompanyStatus(currentCompanyStatus);
					} catch(e) {
						logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (4) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
						props.logOut();
						return;
					} // end catch		 		
					
				}				
				
				// Check if activation token has updateAt date before received token. 
				if (response.data.changedActivationtoken) {

					try {
						var activationStatusObjDecoded = jwtDecode(response.data.activationStatusToken);
						var activationStatus = activationStatusObjDecoded.currentStatus;
						if (activationStatus == null) {
							props.setAlertTitle("Ops! Parece que há um erro nos dados armazenados!");
							props.setAlertBody("Desconectamos o seu usuário da plataforma pois ocorreu uma inconsistência nos dados armazenados no seu dispositivo. Faça o login novamente para corrigir. [2] ");				
							props.setAlert(true);
	
							props.logOut(); 
							return; 
						}
						localStorage.setItem("@dream4/activationStatus",response.data.activationStatusToken);
						props.setActivationStatus(activationStatus);
					} catch(e) {
						logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (5) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
						props.logOut();
						return;
					} // end catch
					
				}

				
			} // end if			

			return;
			
		})
		.catch(error=> {

			setTimeout(() => {
				props.setGlobalLoading(false);
			}, 2000); 	

				// Check if status token has updateAt date before received token. 
				// ... If yes, update LocalStorage Token and data

				// Set CurrentCompanyStatus
				try {
					var companyStatusObjDecoded = jwtDecode(resultCompanyStatus); 
					var currentCompanyStatus = companyStatusObjDecoded.currentStatus;
					if (currentCompanyStatus == null) {
						props.setAlertTitle("Ops! Parece que há um erro nos dados armazenados!");
						props.setAlertBody("Desconectamos o seu usuário da plataforma pois ocorreu uma inconsistência nos dados armazenados no seu dispositivo. Faça o login novamente para corrigir. [1] ");				
						props.setAlert(true);

						props.logOut(); 
						return; 
					}
					props.setCurrentCompanyStatus(currentCompanyStatus);
				} catch(e) {
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (4) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					props.logOut();
					return;
				} // end catch
				
				// Check if activation token has updateAt date before received token. 
				// ... If yes, update LocalStorage Token and data	

				// Set ActivationStatus
				try {
					var activationStatusObjDecoded = jwtDecode(resultActivationStatus);
					var activationStatus = activationStatusObjDecoded.currentStatus;
					if (activationStatus == null) {
						props.setAlertTitle("Ops! Parece que há um erro nos dados armazenados!");
						props.setAlertBody("Desconectamos o seu usuário da plataforma pois ocorreu uma inconsistência nos dados armazenados no seu dispositivo. Faça o login novamente para corrigir. [2] ");				
						props.setAlert(true);

						props.logOut(); 
						return; 
					}
					props.setActivationStatus(activationStatus);
				} catch(e) {
					logger.debug('<<<<<<<<<<<<<<<<<<<< LOGGED OUT (5) >>>>>>>>>>>>>>>>>>>>>>>>>> ');
					props.logOut();
					return;
				} // end catch		

				// Set Retry User Data flags
				// localStorage.setItem("retryUserData",1);
				// localStorage.setItem("retryUserDataReason",error.message);
				// localStorage.setItem("retryUserDataLastUpdate",moment().format("YYYY-MM-DD HH:mm"));					
				
				// Graceful degradation: API call failed but the JWT in
				// localStorage is still authoritative. Mirror the success
				// branch (lines 561-564 / 606-609), including setUserRights —
				// otherwise userRights stays at the reducer initialState ([])
				// after F5/remount and the admin menu items vanish.
				props.setMasterUser(userDataInfo.Master === 0 ? false : true);
				props.setAgencyName(userDataInfo.AgencyShortLegalName);
				props.setAgencyUser(userDataInfo.PersonCompleteName);
				props.setUserRights(userDataInfo.Rights ? userDataInfo.Rights : []);


			logger.debug("[alertMessage]--->"+JSON.stringify("Ocorreu um erro geral ao se comunicar com a API. Verifique sua conexão e tente novamente.",null,2));
			return;
		});
				
} // end dispatch

};



export const retrieveSelectableCompanies = () => {
  return async () => {
    try {
      // Autenticação
      const result = JSON.stringify(authStorage.getUserData() || {});
      const userData = JSON.parse(result);
      const token = userData?.userToken;

      const response = await api.get(config.API_URL + '/api/v1/company/retrieveSelectableCompanies', {
        headers: {
          "x-access-token": token,
          Accept: 'application/json',
        }
      });

      if (response.data.success) {
        const formatted = response.data.data.map((item) => ({
          code: item.id,
          name: item.companyName,
		  tradingName: item.tradingName,
        }));
        return { success: true, data: formatted };
      } else {
        return { success: false };
      }

    } catch (error) {
      logger.error('Erro ao buscar agências:', error.message);
      return { success: false };
    }
  };
};

export const retrieveSelectableCompanyUsers = (companyId) => {
  return async () => {
    try {
      // Autenticação
      const result = JSON.stringify(authStorage.getUserData() || {});
      const userData = JSON.parse(result);
      const token = userData?.userToken;

      const response = await api.post(
        config.API_URL + '/api/v1/company/retrieveSelectableCompanyUsers',
        { companyId: companyId },
        {
          headers: {
            "x-access-token": token,
            Accept: 'application/json',
          }
        }
      );

      if (response.data.success) {

        const formatted = response.data.data.map((item) => ({
          code: item.CompanyPersonUsers[0]?.id,
          name: item.completeName,
		  firstName: item.firstName,
		  lastName: item.lastName,
        }));
        return { success: true, data: formatted };
      } else {
        return { success: false };
      }

    } catch (error) {
      logger.error('Erro ao buscar funcionários da agência:', error.message);
      return { success: false };
    }
  };
};



	
export const retrieveDashboardOverview = (data, props, options = {}) => {
  // data: { dateFrom?: 'YYYY-MM-DD', dateTo?: 'YYYY-MM-DD' }
  return dispatch => {
    try {
      const raw = localStorage.getItem('@dream4/userData', undefined, true);
      const userObj = JSON.parse(raw);

      const payload = {};
      if (data?.dateFrom) payload.dateFrom = data.dateFrom;
      if (data?.dateTo)   payload.dateTo   = data.dateTo;

      api({
        url: config.API_URL + '/api/v1/dashboard/retrieveOverview',
        method: 'POST',
        data: payload,
        signal: options.signal,
        headers: {
          'x-access-token': userObj.userToken,
          Accept: 'application/json'
        }
      })
      .then((response) => {
        if (response.data?.success) {
          props?.setDashboard && props.setDashboard(response.data);
          props?.setLoading && props.setLoading(false);
        } else {
          props?.setLoading && props.setLoading(false);
          props?.onError && props.onError('Não foi possível carregar o dashboard. [App 1]');
        }
      })
      .catch((error) => {
        // Cancelamento via AbortController: ignora, NÃO toca em UI
        if (isAbortError(error)) return;
        props?.setLoading && props.setLoading(false);
        props?.onError && props.onError('Não foi possível carregar o dashboard. [App 2]');
      });

    } catch (e) {
      props?.setLoading && props.setLoading(false);
      props?.onError && props.onError('Sessão inválida. Faça login novamente. [App 3]');
    }
  };

}


	



